// The `getField()` and `updateField()`
// helper functions, are needed to update
// the mapped fields in a Vuex conform manner.
import { updateField } from 'vuex-map-fields';

export default {
  updateField,
  addTransaction(state){
    state.transactions.push({
      id:0,
      deposit_external_id:"",
      deposit_transaction_external_id: "T" + Math.floor(Math.random() * (1000000000 - 1 + 1)) + 1,
      carrier_external_id:"",
      deposit_transaction_reference_number:"",
      statement_external_id:"",
      amount:0.0,
      is_active: true,
      create_user: "webuser",
      update_user: "webuser"
    });
  },
  onLangChanged (state, payload) {
    window.localStorage.setItem(LANG_KEY, payload.lang)
    payload.i18n.locale = payload.lang
    state.lang = payload.lang
  },
  setLayout(state, payload){
    state.layout=payload;
  },
  setCurrentUser(state,payload){
    state.current_user=payload;
  }
}
